import { TabsProps } from 'antd';
import { TFunction } from 'react-i18next';

export const getAccountTabs = (t: TFunction): TabsProps['items'] => [
  { key: 'ACTIVE', label: t('AccountTabs.active') },
  { key: 'NON_ACTIVE', label: t('AccountTabs.nonActive') },
  { key: 'ARCHIVED', label: t('AccountTabs.archived') },
  { key: 'ALL', label: t('AccountTabs.all') },
];
